import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow--sprite",
  "use": "arrow--sprite-usage",
  "viewBox": "0 0 8 6",
  "content": "<symbol viewBox=\"0 0 8 6\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow--sprite\">\n<path d=\"M0.94 0.530029L4 3.58336L7.06 0.530029L8 1.47003L4 5.47003L0 1.47003L0.94 0.530029Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol